import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";

import SingleTextFieldDialog from "../SingleTextField";
import * as actions from "../../../store/actions";
import * as appsyncOperations from "../../../utils/appsyncOperations";

const UpdateDivision = ({
  open,
  onClose,
  division,
  dispatch,
  enqueueSnackbar,
}) => {
  const updateDivision = async (divisionName) => {
    return await appsyncOperations.updateDivision({
      divisionId: division.divisionId,
      displayName: divisionName,
    });
  };

  const onUpdateDivisionSuccess = (division) => {
    onClose();
    enqueueSnackbar("Update successful!", { variant: "success" });
    dispatch(actions.divisions.setDivision(division));
  };

  return (
    <SingleTextFieldDialog
      isOpen={open}
      onClose={onClose}
      label="Edit division name"
      inputLabel="Name"
      startingValue={division.displayName}
      submitLabel="Update"
      cancelLabel="Cancel"
      onSubmit={updateDivision}
      onSuccess={onUpdateDivisionSuccess}
    />
  );
};

export default withSnackbar(connect()(UpdateDivision));
